// avatarList.js
export const avatars = [
    'https://img.icons8.com/color/2x/iron-man.png',
    'https://img.icons8.com/color/2x/spiderman-head.png',
    'https://img.icons8.com/color/2x/captain-america.png',
    'https://img.icons8.com/color/2x/deadpool.png',
    'https://img.icons8.com/color/2x/wolverine.png',
  ];
  